import * as Muicon from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { translateText } from '../../../language'
import { useThemeMode } from '../../../theme'
import * as CustomIcons from '../widgets'
import { NotificationModal } from './NotificationModal'

const getGridItemSx = () => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px'
})

const getIconButtonSx = (palette) => ({
  width: '72px',
  height: '72px',
  borderRadius: '22px',
  backgroundColor: palette.headerColor,
  boxShadow: '0 1px 3px rgba(0,0,0,0.18), 0 4px 12px rgba(0,0,0,0.12)',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    backgroundColor: palette.headerColor,
    filter: 'brightness(1.08)'
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(160deg, rgba(255,255,255,0.08) 0%, rgba(0,0,0,0.06) 100%)',
    borderRadius: '22px',
    pointerEvents: 'none'
  },
  '& .MuiSvgIcon-root': {
    fontSize: '58px',
    color: palette.textColor,
    opacity: 0.75,
    position: 'relative',
    zIndex: 1
  }
})

const getLabelSx = (palette) => ({
  fontSize: '0.7rem',
  color: palette.textColor,
  textAlign: 'center',
  lineHeight: 1.2,
  maxWidth: '90px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical'
})

const DeadlineItem = ({ notification, palette }) => {
  const translation = useTranslation()
  const [modalOpen, setModalOpen] = useState(false)

  const titles = notification.titles ?? []
  const label = translateText(titles, translation.i18n)
  const iconName = notification.icon ?? 'EventOutlined'
  const Icon = CustomIcons[iconName] ?? Muicon[iconName] ?? Muicon.EventOutlined

  return (
    <Box sx={getGridItemSx()}>
      <IconButton
        sx={getIconButtonSx(palette)}
        aria-label={label}
        onClick={() => setModalOpen(true)}
      >
        <Icon />
      </IconButton>
      {label && (
        <Typography sx={getLabelSx(palette)}>
          {label}
        </Typography>
      )}
      <NotificationModal
        notification={notification}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </Box>
  )
}

export const TodayDeadlines = ({ notifications }) => {
  const { palette } = useThemeMode()

  if (!notifications || notifications.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        width: '100%',
        padding: '12px 8px 8px',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '12px',
        justifyItems: 'center'
      }}
    >
      {notifications.map((notification, index) => (
        <DeadlineItem
          key={notification.id ?? index}
          notification={notification}
          palette={palette}
        />
      ))}
    </Box>
  )
}
